export default "__VITE_ASSET__ba60d9bb__"